export default __webpack_public_path__ + "static/media/jazan.704d0e0f.mp4";